import styled, { css } from "styled-components";
import { BTTO_WALLET_GLASS } from "../../shared/bettoWalletTheme";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const NavRoot = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 12px;
	width: 100%;
`;

export const NavButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	max-width: 160px;
	height: 48px;
	border-radius: 10px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_WALLET_GLASS.panelBg};
	backdrop-filter: blur(12px) saturate(130%);
	-webkit-backdrop-filter: blur(12px) saturate(130%);
	color: ${BTTO_PROFILE_COLORS.text};
	cursor: pointer;
	transition:
		background 0.2s ease,
		border-color 0.2s ease,
		opacity 0.2s ease;

	&:hover:not(:disabled) {
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
		background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	}

	${({ $primary, $active }) =>
		$primary &&
		$active &&
		css`
			background: ${BTTO_PROFILE_COLORS.primary};
			border-color: ${BTTO_PROFILE_COLORS.primary};
			color: ${BTTO_PROFILE_COLORS.primaryText};

			&:hover:not(:disabled) {
				background: ${BTTO_PROFILE_COLORS.primaryDark};
				border-color: ${BTTO_PROFILE_COLORS.primaryDark};
			}
		`}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
	}
`;
